import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import LogoLoader from '../components/Loading/LogoLoader';
import { useAuth } from '../auth/AppAuth';
import { isVictoryLiveHosted } from '../utils/whitelabel-consts';

export default function AuthCallback() {
  const { error, isAuthenticated, isLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (error && error.message === 'Invalid state') {
      // Take them back to the start, which should prompt them to log back in again
      navigate('/');
    } else if (error && error.message !== 'Invalid state') {
      throw new Error(error.message);
    } else if (isVictoryLiveHosted && !isLoading && !isAuthenticated) {
      navigate('/');
    }
  }, [error, isAuthenticated, isLoading, navigate]);

  return <LogoLoader />;
}
